import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from "react-router-dom";

import config from '../config.json'

import NavegacionSecciones from './navegacionSecciones';
import Visor from './visor';

import FeatureLayer from '@arcgis/core/layers/FeatureLayer';

import { getValConfigVisoresIfDefault, getValorTablaParametros } from './../utils/mapaUtils';
import { EstadoCargaTablaParametros } from './../utils/enums';
import { AtributosVisor, Seccion, PosMapa } from '../classes/mapaClasses';
import { getColoresGlobales } from './../utils/domUtils';

import { isMobileOnly } from 'react-device-detect';
import MenuInicio from './menuInicio';

function ContainerGeneral() {

    const coloresGlobales = getColoresGlobales()

    const navigate = useNavigate();

    let { codigoSeccion: codigoSeccionRuta, codigoVisor: codigoVisorRuta, codigoBase: codigoBaseRuta, tipo: tipoRuta, tiponav } = useParams();
    const esNav = tipoRuta === config.tipoRutaNavegarGeneral;
    const esNavSoloSeccion = esNav && (tiponav === config.tipoNavegacionSoloSeccionIni ||  tiponav === config.tipoNavegacionSoloSeccion);
    const esHome = codigoBaseRuta === config.identificadorHome
    const [parametros, setParametros] = useState(null);
    const [datosVisorUrl, setDatosVisorUrl] = useState(null);
    const [seccionesAmbiente, setSeccionesAmbiente] = useState(null);
    const [seccionesNavegarVisible, setSeccionesNavegarVisible] = useState(false);
    const [tablaParametrosCargada, setTablaParametrosCargada] = useState(EstadoCargaTablaParametros.noSolicitada);

    const { datosVisorBase, urlBaseIconosNavegacion, extensionIconosNavegacion, maxSeccionesNavegacion, maxSeccionesNavegacionMob, urlBaseVisoresEmbebidos, codigoWebMapIdUrlEmbebida, mostrarMenuNoVisorBase } = config.parametrosCodigos.navegacion;

    //Limpia datosVisorUrl en caso de que haya cambio de URL por navegador atrás/adelante
    useMemo(()=>{
        if (datosVisorUrl && (codigoSeccionRuta !== datosVisorUrl.codigoSeccion ||  codigoVisorRuta !== datosVisorUrl.codigoVisor || esHome)){
            setDatosVisorUrl(null);
            setSeccionesNavegarVisible(false);
        }
    }, [datosVisorUrl, codigoSeccionRuta, codigoVisorRuta, esHome])

    //Carga configuraciones: parametros
    useEffect(() => {
        const featureTableParametrosAux = new FeatureLayer ({
            url: config.urlConfigParametros
        })
        if (featureTableParametrosAux){
            featureTableParametrosAux.load().then(featureTableParametros => {
                setTablaParametrosCargada(EstadoCargaTablaParametros.cargada);
                featureTableParametros.queryFeatures().then(({ features }) => {
                    const parametrosAux = {};
                    features.forEach(({ attributes }) => {
                        parametrosAux[attributes[config.camposParametros.codigo]] = getValorTablaParametros(attributes[config.camposParametros.tipoValor], attributes[config.camposParametros.valor]);
                    })
                    setParametros(parametrosAux);
                });
            }).catch(e => {
                setTablaParametrosCargada(EstadoCargaTablaParametros.errorCarga);
                console.log(`No fue posible cargar la tabla de parámetros de configuración (Servicio: ${config.urlConfigParametros}): ${e.name}`);
            });
        } else {
            setTablaParametrosCargada(EstadoCargaTablaParametros.errorCarga);
            console.log(`No fue posible leer el servicio de la tabla de parámetros de configuración (${config.urlConfigParametros})`);
        }
    }, [])

    //Carga seccionesAmbiente
    useEffect(() => {
        if (parametros){
            if ((codigoSeccionRuta && codigoVisorRuta) || esHome){
                if (!seccionesAmbiente){
                    const { codigoSeccion: campoCodigoSeccion, codigoVisor: campoCodigoVisor, nombre: campoNombre, webMapId: campoWebMapId, centerAndZoom: campoCenterAndZoom, nombreSeccion: campoNombreSeccion, ordenSeccion: campoOrdenSeccion, infoAdicional: campoInfoAdicional, institucional: campoInfoInstitucional, activo: campoActivo, urlTablero: campoUrlTablero } = config.camposVisores;

                    const featureTableVisores = new FeatureLayer ({ url: config.urlConfigVisores });
                    const queryVisores = featureTableVisores.createQuery();
                    queryVisores.orderByFields = [campoOrdenSeccion, campoInfoInstitucional, campoNombre]; //campoInfoInstitucional hace que estén en orden (Públicos y luego Institucionales) en visores de SeccionNavegar
                    queryVisores.where = `${campoActivo} = ${config.codigosCampoActivoVisores.activo} OR ${campoActivo} = ${config.codigosCampoActivoVisores.actSoloDirecto}`;
                    if (config.urlBase === config.urlBaseDev){
                        queryVisores.where += `OR ${campoActivo} = ${config.codigosCampoActivoVisores.actSoloDev} OR ${campoActivo} = ${config.codigosCampoActivoVisores.actSoloDirectoSoloDev}`;
                    }
                    featureTableVisores.queryFeatures(queryVisores).then(({ features }) => {
                        const seccionesAmbienteAux = [];
                        features.forEach(feature => {
                            const attributesAux = feature.attributes;
                            const indexSeccionExistente = seccionesAmbienteAux.findIndex((x => x.codigo === attributesAux[campoCodigoSeccion]));
                            const [codigoSeccionAux, codigoVisorAux] = parametros[datosVisorBase].split(',');
                            const esInicio = codigoSeccionAux === attributesAux[campoCodigoSeccion] && codigoVisorAux === attributesAux[campoCodigoVisor];
                            const auxCenterAndZoom = getValConfigVisoresIfDefault(attributesAux[campoCenterAndZoom], parametros, config.parametrosCodigos.defaults.centerAndZoom);
                            const [lon, lat, zoom] = auxCenterAndZoom.split(',');
                            const atributosVisorAgregar = new AtributosVisor (
                                attributesAux[campoCodigoSeccion],
                                attributesAux[campoCodigoVisor],
                                attributesAux[campoNombre],
                                attributesAux[campoWebMapId],
                                attributesAux[campoCenterAndZoom],
                                attributesAux[campoNombreSeccion],
                                attributesAux[campoInfoAdicional],
                                attributesAux[campoInfoInstitucional],
                                attributesAux[campoActivo],
                                attributesAux[campoUrlTablero],
                                esInicio,
                                new PosMapa(parseFloat(lon), parseFloat(lat), parseInt(zoom))
                            );
                            if (indexSeccionExistente > -1){
                                seccionesAmbienteAux[indexSeccionExistente].visores.push(atributosVisorAgregar);
                            } else {
                                seccionesAmbienteAux.push(new Seccion(atributosVisorAgregar.codigoSeccion, atributosVisorAgregar.nombreSeccion, [atributosVisorAgregar], atributosVisorAgregar.esInicio))   
                            }
                        });
                        setSeccionesAmbiente(seccionesAmbienteAux);
                    })
                }            
            } else if (!tipoRuta) { //Es root URL
                if (parametros[mostrarMenuNoVisorBase]){
                    navigate(`/${config.identificadorHome}`)
                } else {
                    const [codigoSeccionAux, codigoVisorAux] = parametros[datosVisorBase].split(',');
                    navigate(`/${codigoSeccionAux}/${codigoVisorAux}/${config.tipoRutaNavegarGeneral}`);
                }
            }
        }

    }, [seccionesAmbiente, parametros, codigoSeccionRuta, codigoVisorRuta, tipoRuta, datosVisorBase, mostrarMenuNoVisorBase, esHome, navigate])

    // Carga datos de visor referenciado en la URL:
    useEffect(() => {
        if (seccionesAmbiente){
            setDatosVisorUrl(null);
            const seccionAmbienteAsociada = seccionesAmbiente.find(x => x.codigo === codigoSeccionRuta);
            if (seccionAmbienteAsociada) {
                const datosVisorAux = seccionAmbienteAsociada.visores.find(x => x.codigoVisor === codigoVisorRuta);
                if (datosVisorAux) {
                    if (!esNav || (datosVisorAux.activo !== config.codigosCampoActivoVisores.actSoloDirectoSoloDev && datosVisorAux.activo !== config.codigosCampoActivoVisores.actSoloDirecto)){
                        //Si no es navegación no deja cargar los Directos
                        setDatosVisorUrl(datosVisorAux);
                        if (parametros[codigoWebMapIdUrlEmbebida] === datosVisorAux.webMapId) {
                            setSeccionesNavegarVisible(true); //En visor embebido no tiene que esperar que carguen widgets, se muestra inmediatamente
                        }
                    }
                }
            }
        }

    }, [esNav, seccionesAmbiente, codigoSeccionRuta, codigoVisorRuta, tipoRuta, codigoWebMapIdUrlEmbebida, parametros])

    if (tablaParametrosCargada === EstadoCargaTablaParametros.cargada){
        if (!parametros || (!datosVisorUrl && !esHome)  || !seccionesAmbiente){
            return null;
        }
    } else if (tablaParametrosCargada === EstadoCargaTablaParametros.noSolicitada){
        return null;
    } else if (tablaParametrosCargada === EstadoCargaTablaParametros.errorCarga) {
        return (
            <div className='panelAviso panelIndisponibilidad'>
                En estos momentos no se encuentra disponible la información de los GEOVISORES.
                <br/>
                No tardaremos en ponerla a tu disposición, visítanos más tarde"
            </div>
        )
    }

    const seccionesNavegar = [];
    seccionesAmbiente.forEach(x => {
        const visoresNavegarSecc = x.visores.filter(y => y.activo !== config.codigosCampoActivoVisores.actSoloDirectoSoloDev && y.activo !== config.codigosCampoActivoVisores.actSoloDirecto);
        if (visoresNavegarSecc.length > 0){
            if (esNavSoloSeccion){
                if (codigoSeccionRuta === x.codigo){
                    seccionesNavegar.push(new Seccion(x.codigo, x.nombre, visoresNavegarSecc, x.esDeVisorInicio));
                }
            } else {
                if (!(tipoRuta === config.tipoRutaNavegarGeneral && tiponav === config.tipoNavegacionSinIni && x.esDeVisorInicio)){
                    seccionesNavegar.push(new Seccion(x.codigo, x.nombre, visoresNavegarSecc, x.esDeVisorInicio));
                }
            }
        }
    });

    if (esHome && seccionesNavegar.length > 0){
        return (
            <MenuInicio
                seccionesNavegar = {seccionesNavegar}
                urlBaseIconos={parametros[urlBaseIconosNavegacion]}
                extensionIconos={parametros[extensionIconosNavegacion]}
            />
        )
    }

    const urlBaseStd = parametros[urlBaseVisoresEmbebidos].endsWith("/") ? parametros[urlBaseVisoresEmbebidos] : `${parametros[urlBaseVisoresEmbebidos]}/`; //Agrega slash final si no lo tiene

    return (
        <div className="divMapView">
            <div id='divIcono'>
                <img src={process.env.PUBLIC_URL + '/logoh.png'} alt='ONL'/>
            </div>
            <div className='panelCentrado panelAviso' style={{zIndex: "9999", display: seccionesNavegarVisible ? "none" : "block"}}>
                <div className='blink' style={{color: coloresGlobales.base}}>
                    Cargando...
                </div>
            </div>
            {
                parametros[codigoWebMapIdUrlEmbebida] === datosVisorUrl.webMapId ?
                <div className="divMapView">
                    <div className="panelAviso panelTitulo">
                        {datosVisorUrl.nombre}
                    </div>   
                    <object type="text/html" data={`${urlBaseStd}${codigoVisorRuta}`}
                        style={{width:"100%", height:"100%"}}>
                    </object>
                </div>   
                :
                <Visor
                    parametros={parametros}
                    parametrosVisor={datosVisorUrl}
                    setSeccionesNavegarVisible={setSeccionesNavegarVisible}
                /> 
            }   

            { 
                (!esNav || !seccionesNavegarVisible || (esNavSoloSeccion && (datosVisorUrl.esInicio || seccionesNavegar[0].visores.length === 1)) ) ? null : 
                <NavegacionSecciones 
                    visible={true}
                    seccionesNavegar={seccionesNavegar}
                    numSeccionesMax={isMobileOnly ? parametros[maxSeccionesNavegacionMob] : parametros[maxSeccionesNavegacion]} 
                    urlBaseIconos={parametros[urlBaseIconosNavegacion]}
                    extensionIconos={parametros[extensionIconosNavegacion]}
                    parametrosVisor={datosVisorUrl}
                    codigoWebMapIdUrlEmbebida={parametros[codigoWebMapIdUrlEmbebida]}
                    mostrarMenuNoVisorBase={parametros[mostrarMenuNoVisorBase]}
                /> 
            }
        </div>
    );
}

export default ContainerGeneral;